import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=04964a14&scoped=true&"
import script from "./activityList.vue?vue&type=script&lang=js&"
export * from "./activityList.vue?vue&type=script&lang=js&"
import style0 from "./activityList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./activityList.vue?vue&type=style&index=1&id=04964a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04964a14",
  null
  
)

export default component.exports